export enum Threshold {
  Exact = "exact",
  Strict = "strict",
  Loose = "loose",
}

/** All confidence-level names. Prefer this over recreating the enum values. */
export const THRESHOLDS = Object.values(Threshold);

export type ThresholdDefinition<T extends Threshold = Threshold> = {
  name: T;
  value: number;
};

/**
 * Threshold names enabled this run that pIDR did not cluster last run and need to be re-clustered
 */
export function getNewlyEnabledThresholds(
  priorThresholds: string[],
  currentThresholds: string[],
): string[] {
  if (priorThresholds.length === 0) {
    return [];
  }
  const prior = new Set(priorThresholds);
  return currentThresholds.filter((threshold) => !prior.has(threshold));
}

export const thresholdDefinitions: {
  [K in Threshold]: ThresholdDefinition<K>;
} = {
  [Threshold.Exact]: {
    name: Threshold.Exact,
    value: 1.0,
  },
  [Threshold.Strict]: {
    name: Threshold.Strict,
    value: 0.9,
  },
  [Threshold.Loose]: {
    name: Threshold.Loose,
    value: 0.8,
  },
};
